import Home from '@/views/home/Index.vue';
// import Home1 from '@/views/home1/Index.vue';
import Login from '@/views/login/Index.vue';
import Demo from '@/views/demo/Index.vue';
import Panorama from '@/views/vr/Panorama.vue';
import GLTFOrbit from '@/views/vr/GLTFOrbit.vue';
import GLTFPointer from '@/views/vr/GLTFPoint.vue';

// 全局页面
export default [
    {
        path: '/',
        name: 'index',
        redirect: '/home',
    },
    {
        path: '/home',
        name: 'home',
        component: Home,
        meta: {title: '首页'},
    },
    // 非平台用户的品牌授权申请页面
    {
        path: '/home/brand-auth-apply',
        name: 'enterprise-brand-auth-apply',
        component: () => import(/* webpackChunkName: "org" */ '@/views/brand-audit/apply/BrandAuthApplyAdd.vue'),
        meta: {title: '会员/企业管理'},
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {fullPage: true, ignoreAuth: true},
    },
    {
        path: '/demo',
        name: 'demo',
        component: Demo,
        meta: {title: '测试页面'},
    },
    {
        path: '/vr',
        name: 'vr',
        component: Panorama,
        meta: {title: '全景图', fullPage: true, ignoreAuth: true},
    },
    {
        path: '/gltf-orbit',
        name: 'gltf-orbit',
        component: GLTFOrbit,
        meta: {title: 'GLTF 预览', fullPage: true, ignoreAuth: true},
    },
    {
        path: '/gltf-pointer',
        name: 'gltf-pointer',
        component: GLTFPointer,
        meta: {title: 'GLTF 预览', fullPage: true, ignoreAuth: true},
    },
];
